(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isManagedByGroup = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Check if managed by StickyGroupManager (set after manager initializes)
      // Use MutationObserver to detect when managedByGroup attribute is set
      this.checkManagedStatus();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Listen for sticky events from StickyGroupManager
      this.addEventListener('stickyHide', this.onManagedHide.bind(this));
      this.addEventListener('stickyReveal', this.onManagedReveal.bind(this));
      this.addEventListener('stickyReset', this.onManagedReset.bind(this));

      // Only attach scroll handler if not managed by group
      if (!this.isManagedByGroup) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    checkManagedStatus() {
      // Check if already managed
      if (this.dataset.managedByGroup === 'true') {
        this.isManagedByGroup = true;
        return;
      }

      // Watch for the attribute to be set by the manager
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-managed-by-group' && this.dataset.managedByGroup === 'true') {
            this.isManagedByGroup = true;
            // Remove scroll handler if it was attached
            if (this.onScrollHandler) {
              window.removeEventListener('scroll', this.onScrollHandler);
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(this, { attributes: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Skip if managed by group
      if (this.isManagedByGroup) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // Event handlers for when managed by StickyGroupManager
    onManagedHide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    onManagedReveal() {
      // Any reveal-specific logic
    }

    onManagedReset() {
      // Any reset-specific logic
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients-directory"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const SECTION_SELECTOR = '.ingredients-directory';

    function init(section) {
      const triggers = section.querySelectorAll('.ingredients-directory__trigger');
      const chips = section.querySelectorAll('.ingredients-directory__chip');
      const items = section.querySelectorAll('.ingredients-directory__item');

      /* --- Accordion --- */
      triggers.forEach(function(trigger) {
        trigger.addEventListener('click', function() {
          const expanded = trigger.getAttribute('aria-expanded') === 'true';
          const contentId = trigger.getAttribute('aria-controls');
          const content = document.getElementById(contentId);
          if (!content) return;

          if (expanded) {
            /* Collapse */
            trigger.setAttribute('aria-expanded', 'false');
            content.style.maxHeight = content.scrollHeight + 'px';
            requestAnimationFrame(function() {
              content.style.maxHeight = '0';
              content.style.opacity = '0';
            });
            setTimeout(function() {
              content.hidden = true;
              content.classList.remove('is-open');
            }, 350);
          } else {
            /* Expand */
            content.hidden = false;
            trigger.setAttribute('aria-expanded', 'true');
            requestAnimationFrame(function() {
              content.style.maxHeight = content.scrollHeight + 'px';
              content.style.opacity = '1';
              content.classList.add('is-open');
            });
            /* Clear inline max-height after transition so content can reflow */
            setTimeout(function() {
              content.style.maxHeight = 'none';
            }, 360);
          }
        });
      });

      /* --- Category Filter --- */
      chips.forEach(function(chip) {
        chip.addEventListener('click', function() {
          /* Update active state */
          chips.forEach(function(c) {
            c.classList.remove('ingredients-directory__chip--active');
            c.setAttribute('aria-pressed', 'false');
          });
          chip.classList.add('ingredients-directory__chip--active');
          chip.setAttribute('aria-pressed', 'true');

          var category = chip.getAttribute('data-category');

          /* Filter items */
          items.forEach(function(item) {
            if (category === 'all') {
              item.hidden = false;
              return;
            }
            var cats = (item.getAttribute('data-categories') || '').split(',');
            item.hidden = cats.indexOf(category) === -1;
          });
        });
      });
    }

    /* Init all instances on the page */
    document.querySelectorAll(SECTION_SELECTOR).forEach(init);

    /* Re-init on Shopify section events (editor) */
    if (Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:load', function(e) {
        var section = e.target.querySelector(SECTION_SELECTOR);
        if (section) init(section);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
